// ダッシュボードレンズ（S-061-4 / DEC-057 決定内容2 / 設計doc §3-1）。
//
// Web 版ダッシュボードのトップ表示を「営業（約束ベース Focus）」と「建築（物件別）」で
// 出し分けるためのレンズ。これは **本人が 1 回選ぶ専用フィールド** `users/{uid}.dashboardLens`
// を SSOT とする。
//
// なぜ industry を直読しないのか（F1 = industry の二重用途）:
//   `users/{uid}.industry` はオンボーディング（construction/sales/other）に加え、
//   アプリの辞書分野セレクター（general/hvac/electrical/all）が同じフィールドを上書きする。
//   industry を直読すると、ユーザーが辞書分野を変えた瞬間にトップ画面が無言で入れ替わってしまう。
//   そこで dashboardLens を新設し、industry は **初期値の導出にだけ**（集合マッチで）使う。
//   いったん dashboardLens が設定されたら、辞書変更では絶対にフリップしない。

// 解決後の確定レンズ。
export type DashboardLens = 'focus' | 'construction';

// users/{uid}.dashboardLens に保存される値。未設定（null/欠損）は industry から導出する。
export type DashboardLensSetting = DashboardLens | null;

// industry が建築系（建築レンズを初期提案する集合）と判定される値。
// オンボの 'construction' に加え、辞書セレクターの 'hvac'（空調）/ 'electrical'（電気）/
// 'all'（設備系横断）を含める。創業者のコア標的（設備系現場）が営業レンズに落ちないようにする。
export const CONSTRUCTION_INDUSTRIES = ['construction', 'hvac', 'electrical', 'all'] as const;

// industry が建築系集合に属するか。
export function isConstructionIndustry(industry: string | null | undefined): boolean {
  if (!industry) return false;
  return (CONSTRUCTION_INDUSTRIES as readonly string[]).includes(industry);
}

// レンズ解決の純関数（設計doc §3-1）。
//
//   dashboardLens が 'focus' / 'construction' なら、それをそのまま使う（本人選択が最優先）。
//   未設定（null/undefined/未知値）のときだけ industry から導出する:
//     industry ∈ {construction, hvac, electrical, all} → 'construction'
//     それ以外（other/general/空/欠損）           → 'focus'（既存ユーザー無風）。
//
// dashboardLens に未知の文字列が入っていた場合も industry 導出にフォールバックする
//（前方互換: 将来レンズが増えても古いクライアントが壊れない）。
export function resolveDashboardLens(
  dashboardLens: string | null | undefined,
  industry: string | null | undefined,
): DashboardLens {
  if (dashboardLens === 'focus' || dashboardLens === 'construction') {
    return dashboardLens;
  }
  return isConstructionIndustry(industry) ? 'construction' : 'focus';
}

// トグル UI のラベル（営業向けであることを明示する＝けんじ確定文言の流儀）。
export function dashboardLensLabel(lens: DashboardLens): string {
  return lens === 'construction' ? '物件まとめ' : '約束ベース（営業向け）';
}
